/* LaCasitaExpress: guía de tallas (modal) y botón "Realizar pedido" (agrega al carro y va directo al pago). */
(function () {
  // Guía de tallas
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-lc-gt-open]');
    if (open) {
      var dlg = open.parentElement.querySelector('dialog.lc-gt__dlg');
      if (dlg && dlg.showModal) dlg.showModal();
      return;
    }
    if (e.target.closest('[data-lc-gt-close]') || e.target.matches('dialog.lc-gt__dlg')) {
      var d = e.target.closest('dialog');
      if (d) d.close();
    }
  });

  // Reseñas: "Ver todas las opiniones" baja hasta la sección completa de LAI
  function lcRvTarget() {
    var all = document.querySelectorAll('.scm-reviews-importer');
    for (var i = 0; i < all.length; i++) if (!all[i].closest('.lc-rv') && !all[i].closest('.product__info-container')) return all[i];
    return null;
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-lc-rv-more]')) return;
    var t = lcRvTarget();
    if (t) t.closest('.shopify-section').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  document.addEventListener('DOMContentLoaded', function () {
    if (!lcRvTarget()) document.querySelectorAll('[data-lc-rv-more]').forEach(function (b) { b.hidden = true; });
  });

  // Reseñas compactas: arma las tarjetas con los datos reales de LAI (metafield scm_review_importer.reviewsData)
  function lcRvParse(raw) {
    var o = JSON.parse(raw);
    var items = typeof o === 'string' ? o : o && o.reviewItems;
    if (typeof items === 'string' && items.trim().charAt(0) === '{') items = JSON.parse(items);
    if (typeof items === 'string') {
      var bin = atob(items), bytes = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
      items = JSON.parse(new TextDecoder().decode(bytes));
    }
    return (items && items.reviews) || [];
  }
  function lcEsc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function lcRvBuild(track) {
    var data = track.parentElement.querySelector('[data-lc-rv-data]');
    var reviews = [];
    try { reviews = lcRvParse(data.textContent); } catch (err) { reviews = []; }
    reviews = reviews.filter(function (r) { return r.rating >= 4 && r.review; });
    reviews.sort(function (a, b) { return ((b.photosArray || []).length ? 1 : 0) - ((a.photosArray || []).length ? 1 : 0); });
    reviews = reviews.slice(0, 12);
    if (!reviews.length) { track.remove(); var nav = data.parentElement.querySelector('.lc-rv__nav'); if (nav) nav.remove(); return; }
    track.innerHTML = reviews.map(function (r) {
      var ph = (r.photosArray || [])[0];
      var name = lcEsc(r.author);
      var media = ph
        ? '<img class="lc-rv__ph" src="' + lcEsc(ph) + '_220x220.jpg" onerror="this.onerror=null;this.src=\'' + lcEsc(ph) + '\'" alt="Foto de ' + name + '" loading="lazy" width="66" height="84">'
        : '<span class="lc-rv__av" aria-hidden="true">' + lcEsc((r.author || '?').charAt(0)) + '</span>';
      var stars = '★★★★★'.slice(0, Math.round(r.rating)) + '<span style="color:#E2DCCF">' + '★★★★★'.slice(Math.round(r.rating)) + '</span>';
      return '<div class="lc-rv__card" role="listitem">' + media + '<div class="lc-rv__txt"><span class="lc-rv__st" aria-label="' + r.rating + ' de 5">' + stars + '</span><p>' +
        lcEsc(String(r.review).replace(/\s*\n\s*/g, ' ')) + '</p><span class="lc-rv__by">' + name + '</span></div></div>';
    }).join('');
  }
  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-lc-rv-prev], [data-lc-rv-next]');
    if (!nav) return;
    var track = nav.closest('.lc-rv').querySelector('[data-lc-rv-track]');
    if (!track) return;
    var card = track.querySelector('.lc-rv__card');
    var step = card ? card.getBoundingClientRect().width + 10 : track.clientWidth * 0.8;
    track.scrollBy({ left: nav.hasAttribute('data-lc-rv-next') ? step : -step, behavior: 'smooth' });
  });
  function lcRvInit() { document.querySelectorAll('[data-lc-rv-track]').forEach(lcRvBuild); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lcRvInit); else lcRvInit();

  // Valoración junto al título: baja hasta las opiniones de la ficha (o a la sección completa de LAI)
  document.addEventListener('click', function (e) {
    var v = e.target.closest('[data-lc-valoracion]');
    if (!v) return;
    var t = document.querySelector('.lc-rv') || (lcRvTarget() && lcRvTarget().closest('.shopify-section'));
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  // Realizar pedido: espera a que terminen las llamadas al carro (Kaching puede hacer varias) y luego va al pago.
  var going = false;
  var pending = 0;
  var timer = null;
  var safety = null;
  var activeBtn = null;

  function reset() {
    going = false;
    pending = 0;
    clearTimeout(timer);
    clearTimeout(safety);
    if (activeBtn) {
      activeBtn.classList.remove('loading');
      activeBtn.removeAttribute('aria-disabled');
    }
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (going && pending === 0) window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout';
    }, 700);
  }
  function isCart(url) {
    return /\/cart\/(add|change|update)/.test(url || '');
  }
  function track(promiseLike) {
    pending++;
    clearTimeout(timer);
    return promiseLike;
  }
  function done(ok) {
    pending = Math.max(0, pending - 1);
    if (!going) return;
    if (ok) schedule();
    else reset();
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    var p = origFetch.apply(this, arguments);
    if (going && isCart(url)) {
      track(p).then(
        function (r) { done(r.ok); },
        function () { done(false); }
      );
    }
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._lcUrl = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (going && isCart(this._lcUrl)) {
      pending++;
      clearTimeout(timer);
      this.addEventListener('loadend', function () { done(this.status >= 200 && this.status < 300); });
    }
    return origSend.apply(this, arguments);
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lc-pedido]');
    if (!btn) return;
    e.preventDefault();
    if (going) return;
    var scope = btn.closest('.product__info-container') || document;
    var form = scope.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('product-form form[data-type="add-to-cart-form"]');
    var atc = form && form.querySelector('[type="submit"][name="add"]');
    if (!atc || atc.disabled) return;
    going = true;
    activeBtn = btn;
    btn.classList.add('loading');
    btn.setAttribute('aria-disabled', 'true');
    safety = setTimeout(reset, 12000);
    atc.click();
  });
})();
